import { useState, useEffect } from 'react';
import default_Img from '@/assets/images/usual/default_img.png';
import default_vertical_img from '@/assets/images/usual/vertical.png';
const GrtImage = (props) => {
    let default_img = props.vertical ? default_vertical_img : default_Img;
    let { src, ...otherProps } = props;
    const [imgSrc, setImgSrc] = useState(src || default_img);
    const onError = () => {
        setImgSrc(props.errimg || default_img);
    };
    useEffect(() => {
        if (!props.src) {
            setImgSrc(default_img);
            return;
        }
        setImgSrc(props.src);
    }, [props.src]);
    return (
        <>
            <img {...otherProps} src={imgSrc} onError={onError} alt="" />
        </>
    );
};
export default GrtImage;
